export const FormSubmittedToast = "Form submitted successfully. We'll be in touch soon!"
export const FormRequiredToast = 'Please fill in all fields marked with * before submitting.'
export const SubscribingToast = 'Thanks for subscribing! You’ll now get our latest updates'

export const ApiErrorToast = 'Oops! Something went wrong. Please try again'
